import { Component, TemplateRef, ViewChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-policy-modal',
  standalone: true,
  imports: [CommonModule, NgbModalModule],
  template: `
    <div class="policy-links" *ngIf="showButtons">
      <button class="btn btn-primary" (click)="openPrivacy()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <circle cx="12" cy="16" r="1"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        {{ t('privacyPolicy') }}
      </button>
      <button class="btn btn-primary" (click)="openTerms()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14,2 14,8 20,8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10,9 9,9 8,9"/>
        </svg>
        {{ t('termsAndConditions') }}
      </button>
      <button class="btn btn-primary" (click)="openRefund()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
          <path d="M3 3v5h5"/>
          <path d="M12 7v5l4 2"/>
        </svg>
        {{ t('cancellationAndRefund') }}
      </button>
      <button class="btn btn-primary" (click)="openShipping()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="1" y="3" width="15" height="13"/>
          <path d="M16 8h4l3 3v5h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        {{ t('shippingAndDelivery') }}
      </button>
    </div>

    <ng-template #privacyTpl let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ t('privacyPolicy') }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('close')"></button>
      </div>
      <div class="modal-body">
        <div class="privacy-policy-content">
          <h6><strong>1. {{ t('privacyPolicySectionIntroduction') }}</strong></h6>
          <p>{{ t('privacyPolicyIntroduction') }}</p>

          <h6><strong>2. {{ t('privacyPolicyInfoWeCollect') }}</strong></h6>
          <p>{{ t('privacyPolicyInfoWeCollectDesc') }}</p>
          <ul>
            <li><strong>{{ t('privacyPolicyPersonalInfo') }}</strong></li>
            <li><strong>{{ t('privacyPolicyUsageData') }}</strong></li>
            <li><strong>{{ t('privacyPolicyHealthData') }}</strong></li>
            <li><strong>{{ t('privacyPolicyPaymentInfo') }}</strong></li>
          </ul>

          <h6><strong>3. {{ t('privacyPolicyHowWeUse') }}</strong></h6>
          <ul>
            <li><strong>{{ t('privacyPolicyHealthcareServices') }}</strong></li>
            <li><strong>{{ t('privacyPolicyMedicalRecords') }}</strong></li>
            <li><strong>{{ t('privacyPolicyCommunication') }}</strong></li>
            <li><strong>{{ t('privacyPolicyTreatmentImprovement') }}</strong></li>
            <li><strong>{{ t('privacyPolicyLegalCompliance') }}</strong></li>
          </ul>

          <h6><strong>4. {{ t('privacyPolicySharingInfo') }}</strong></h6>
          <ul>
            <li><strong>{{ t('privacyPolicyHealthcareProviders') }}</strong></li>
            <li><strong>{{ t('privacyPolicyServiceProviders') }}</strong></li>
            <li><strong>{{ t('privacyPolicyLegalRequirements') }}</strong></li>
            <li><strong>{{ t('privacyPolicyMedicalEmergencies') }}</strong></li>
          </ul>

          <h6><strong>5. {{ t('privacyPolicyDataSecurity') }}</strong></h6>
          <p>{{ t('privacyPolicyDataSecurityDesc') }}</p>

          <h6><strong>6. {{ t('privacyPolicyYourRights') }}</strong></h6>
          <ul>
            <li><strong>{{ t('privacyPolicyAccess') }}</strong></li>
            <li><strong>{{ t('privacyPolicyCorrection') }}</strong></li>
            <li><strong>{{ t('privacyPolicyPortability') }}</strong></li>
            <li><strong>{{ t('privacyPolicyWithdrawal') }}</strong></li>
          </ul>

          <h6><strong>7. {{ t('privacyPolicyConfidentiality') }}</strong></h6>
          <p>{{ t('privacyPolicyConfidentialityDesc') }}</p>

          <h6><strong>8. {{ t('privacyPolicyChildrenPrivacy') }}</strong></h6>
          <p>{{ t('privacyPolicyChildrenPrivacyDesc') }}</p>

          <h6><strong>9. {{ t('privacyPolicyChanges') }}</strong></h6>
          <p>{{ t('privacyPolicyChangesDesc') }}</p>

          <h6><strong>10. {{ t('privacyPolicyContactUs') }}</strong></h6>
          <p>{{ t('privacyPolicyContactUsDesc') }}</p>
           <ul>
             <li>{{ t('privacyPolicyContactEmail') }} dr.piyu2309@gmail.com</li>
             <li>{{ t('privacyPolicyContactPhone') }} +91-98904 46677</li>
             <li>{{ t('privacyPolicyContactAddress') }}
               <ul style="margin-top: 0.5rem; padding-left: 1.5rem;">
                 <li><strong>{{ t('contactLocation_branch1_title') }}:</strong> {{ t('contactLocation_branch1_address') }}</li>
                 <li><strong>{{ t('contactLocation_branch2_title') }}:</strong> {{ t('contactLocation_branch2_address') }}</li>
               </ul>
             </li>
           </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.close('ok')">{{ t('close') }}</button>
      </div>
    </ng-template>

    <ng-template #termsTpl let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ t('termsAndConditions') }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('close')"></button>
      </div>
      <div class="modal-body">
        <p><strong>{{ t('termsIntro')}}</strong></p>
        <ol class="ps-3">
          <li>{{ t('termsPoint1') }}</li>
          <li>{{ t('termsPoint2') }}</li>
          <li>{{ t('termsPoint3') }}</li>
          <li>{{ t('termsPoint4') }}</li>
          <li>{{ t('termsPoint5') }}</li>
          <li>{{ t('termsPoint6') }}</li>
          <li>{{ t('termsPoint7') }}</li>
          <li>{{ t('termsPoint8') }}</li>
        </ol>
        <p class="text-muted mb-0">{{ t('termsFooter') }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.close('ok')">{{ t('close') }}</button>
      </div>
    </ng-template>

    <ng-template #refundTpl let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ t('cancellationAndRefund') }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('close')"></button>
      </div>
      <div class="modal-body">
        <div class="refund-policy-content">
          <h6><strong>1. {{ t('privacyPolicySectionIntroduction') }}</strong></h6>
          <p>{{ t('refundPolicyIntroduction') }}</p>

          <h6><strong>2. {{ t('refundPolicyEligibilityTitle') }}</strong></h6>
          <p>{{ t('refundPolicyEligibilityDesc') }}</p>
          <ul>
            <li><strong>{{ t('refundPolicyIncorrectOrders') }}</strong></li>
            <li><strong>{{ t('refundPolicyServiceIssues') }}</strong></li>
            <li><strong>{{ t('refundPolicyConsultationCancellation') }}</strong></li>
          </ul>

          <h6><strong>3. {{ t('refundPolicyRequestProcessTitle') }}</strong></h6>
          <p>{{ t('refundPolicyRequestProcessDesc') }}</p>
          <ol>
            <li><strong>{{ t('refundPolicyContactUs') }}</strong></li>
            <li><strong>{{ t('refundPolicyReturnAuthorization') }}</strong></li>
            <li><strong>{{ t('refundPolicyProcessingTime') }}</strong></li>
          </ol>

          <h6><strong>4. {{ t('refundPolicyNonRefundableTitle') }}</strong></h6>
          <p>{{ t('refundPolicyNonRefundableDesc') }}</p>
          <ul>
            <li><strong>{{ t('refundPolicyCompletedConsultations') }}</strong></li>
            <li><strong>{{ t('refundPolicyOpenedSupplements') }}</strong></li>
          </ul>

          <h6><strong>5. {{ t('refundPolicyShippingCostsTitle') }}</strong></h6>
          <ul>
            <li><strong>{{ t('refundPolicyReturnShipping') }}</strong></li>
            <li><strong>{{ t('refundPolicyOriginalShippingFees') }}</strong></li>
          </ul>

          <h6><strong>6. {{ t('refundPolicyChangesTitle') }}</strong></h6>
          <p>{{ t('refundPolicyChangesDesc') }}</p>

          <h6><strong>7. {{ t('refundPolicyContactUsTitle') }}</strong></h6>
          <p>{{ t('refundPolicyContactUsDesc') }}</p>
          <ul>
            <li>{{ t('refundPolicyContactEmail') }}</li>
            <li>{{ t('refundPolicyContactPhone') }}</li>
            <li>{{ t('refundPolicyContactAddress') }}
              <ul style="margin-top: 0.5rem; padding-left: 1.5rem;">
                <li><strong>{{ t('contactLocation_branch1_title') }}:</strong> {{ t('contactLocation_branch1_address') }}</li>
                <li><strong>{{ t('contactLocation_branch2_title') }}:</strong> {{ t('contactLocation_branch2_address') }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.close('ok')">{{ t('close') }}</button>
      </div>
    </ng-template>

    <ng-template #shippingTpl let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ t('shippingAndDelivery') }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('close')"></button>
      </div>
      <div class="modal-body">
        <div class="shipping-policy-content">
          <h6><strong>1. Introduction</strong></h6>
          <p>{{ t('shippingPolicyIntroduction') }}</p>

          <h6><strong>2. {{ t('shippingPolicyMethodsTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyMethodsDesc') }}</p>
          <ul>
            <li><strong>{{ t('shippingPolicyStandardShipping') }}</strong></li>
          </ul>

          <h6><strong>3. {{ t('shippingPolicyChargesTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyChargesDesc') }}</p>
          <!-- <ul>
            <li><strong>{{ t('shippingPolicyCodCharges') }}</strong></li>
          </ul> -->

          <h6><strong>4. {{ t('shippingPolicyOrderProcessingTitle') }}</strong></h6>
          <ul>
            <li><strong>{{ t('shippingPolicyProcessingTime') }}</strong></li>
            <li><strong>{{ t('shippingPolicyOrderConfirmation') }}</strong></li>
            <li><strong>{{ t('shippingPolicyShippingConfirmation') }}</strong></li>
            <li><strong>{{ t('shippingPolicySupplementsPackaging') }}</strong></li>
          </ul>

          <h6><strong>5. {{ t('shippingPolicyTrackingTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyTrackingDesc') }}</p>

          <h6><strong>6. {{ t('shippingPolicyAddressTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyAddressDesc') }}</p>

          <h6><strong>7. {{ t('shippingPolicyRestrictionsTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyRestrictionsDesc') }}</p>

          <h6><strong>8. {{ t('shippingPolicyDeliveryIssuesTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyDeliveryIssuesDesc') }}</p>

          <h6><strong>9. {{ t('shippingPolicyReturnsTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyReturnsDesc') }}</p>

          <h6><strong>10. {{ t('shippingPolicySpecialConsiderationsTitle') }}</strong></h6>
          <ul>
            <li><strong>{{ t('shippingPolicyTemperatureControl') }}</strong></li>
            <li><strong>{{ t('shippingPolicyPrescriptionItems') }}</strong></li>
            <li><strong>{{ t('shippingPolicyConsultationMaterials') }}</strong></li>
          </ul>

          <h6><strong>11. {{ t('shippingPolicyChangesTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyChangesDesc') }}</p>

          <h6><strong>12. {{ t('shippingPolicyContactTitle') }}</strong></h6>
          <p>{{ t('shippingPolicyContactDesc') }}</p>
          <ul>
            <li>{{ t('shippingPolicyContactEmail') }}</li>
            <li>{{ t('shippingPolicyContactPhone') }}</li>
            <li>{{ t('shippingPolicyContactAddress') }}
              <ul style="margin-top: 0.5rem; padding-left: 1.5rem;">
                <li><strong>{{ t('contactLocation_branch1_title') }}:</strong> {{ t('contactLocation_branch1_address') }}</li>
                <li><strong>{{ t('contactLocation_branch2_title') }}:</strong> {{ t('contactLocation_branch2_address') }}</li>
              </ul>
            </li>
            <li>{{ t('shippingPolicyBusinessHours') }}</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.close('ok')">{{ t('close') }}</button>
      </div>
    </ng-template>
  `,
  styles: [`
    .policy-links { display:grid; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; gap:.5rem; }
    .btn { 
      padding:.5rem 1rem; 
      font-size:0.9rem; 
      white-space:nowrap; 
      display: flex;
      align-items: center;
      gap: 0.5rem;
      justify-content: center;
    }
    .btn svg { flex-shrink: 0; }
    .privacy-policy-content h6, .refund-policy-content h6, .shipping-policy-content h6 { margin-top: 1.5rem; margin-bottom: 0.5rem; }
    .privacy-policy-content p, .refund-policy-content p, .shipping-policy-content p { margin-bottom: 0.5rem; }
    .privacy-policy-content ul, .refund-policy-content ul, .shipping-policy-content ul { margin-bottom: 0.5rem; padding-left: 1.5rem; }
    .privacy-policy-content li, .refund-policy-content li, .shipping-policy-content li { margin-bottom: 0.25rem; }
    .refund-policy-content ol { margin-bottom: 0.5rem; padding-left: 1.5rem; }
  `]
})
export class PolicyModalComponent {
  @Input() showButtons: boolean = true;

  @ViewChild('privacyTpl', { static: true }) private privacyTpl!: TemplateRef<any>;
  @ViewChild('termsTpl', { static: true }) private termsTpl!: TemplateRef<any>;
  @ViewChild('refundTpl', { static: true }) private refundTpl!: TemplateRef<any>;
  @ViewChild('shippingTpl', { static: true }) private shippingTpl!: TemplateRef<any>;

  constructor(private modalService: NgbModal, private languageService: LanguageService) {}

  open(content: TemplateRef<any>): void {
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  // Methods to open specific modals programmatically
  openPrivacy(): void { this.open(this.privacyTpl); }
  openTerms(): void { this.open(this.termsTpl); }
  openRefund(): void { this.open(this.refundTpl); }
  openShipping(): void { this.open(this.shippingTpl); }

  t(key: string): string {
    return this.languageService.t(key);
  }
}


